import { useContext } from 'react';
import { FormControlLabel, Grid, Checkbox, TextField, MenuItem, Link } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { applicationContext, appUserContext } from 'helpers/services';
import { IBulkEditRequest } from '../BulkEditContext';


interface IProps {
    request: IBulkEditRequest
    updateRequest: (newRequest: IBulkEditRequest) => void
}

let Assignee = ({ request, updateRequest }: IProps) => {
    let { currentUser } = useContext(appUserContext);
    let { assignableUsers } = useContext(applicationContext);


    return (
        <>
            <Grid item xs={4}>
                <FormControlLabel
                    checked={request.changeAssignee}
                    control={<Checkbox />}
                    label={"Assignee"}
                    onChange={(e, value) => {
                        updateRequest({
                            ...request,
                            changeAssignee: value
                        })
                    }}
                />
            </Grid>

            {request.changeAssignee &&
                <Grid item xs={8}>
                    <Autocomplete
                        value={request.assignee}
                        onChange={(event, newValue) =>
                            updateRequest({
                                ...request,
                                assignee: newValue || ''
                            })
                        }
                        getOptionLabel={(option) => assignableUsers.getValueByKey(option, 'email', 'name')}
                        options={[
                            ...assignableUsers
                                .filter(y => y.canWorkOnAllTicket || y.canWorkOnTicketAssignedToMyGroup || y.groups?.find(z => z === "CUSTOMER_SERVICE"))
                                .map(x => x.email)
                        ]}
                        renderInput={(params) =>
                            <TextField {...params}
                                label={"Assignee"}
                                variant="outlined"
                                fullWidth
                                InputProps={{ ...params.InputProps }}
                            />
                        }
                    />
                    {currentUser?.email != request.assignee && currentUser?.canWorkOnAllTicket &&
                        <Link
                            role="button"
                            color="error"
                            variant="body2"
                            style={{ cursor: 'pointer' }}
                            onClick={() => updateRequest({
                                ...request,
                                assignee: currentUser?.email || ''
                            })}
                        >
                            Assign to me
                        </Link>
                    }
                </Grid>
            }
        </>
    )
}

export default Assignee;